import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  fieldsInitial,
  farmerTypeOptions,
  switchEmpFar,
  switchType,
  switchEmplabelFar,
} from "./../model-gatepass";

const GatePassOutForm = (props) => {
  var d = new Date();
  var dateString =
    d.getDate() +
    "/" +
    (d.getMonth() + 1) +
    "/" +
    d.getFullYear() +
    " " +
    d.getHours() +
    ":" +
    d.getMinutes() +
    ":" +
    d.getSeconds();

  const frmRef = useRef({});

  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [integerPattern, setIntegerPattern] = useState(
    localStorage.getItem("integerPattern")
  ); // ;

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );
  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };
  const currentDate = new Date().toISOString().slice(0, 10);

  const [fields, setFields] = useState(fieldsInitial);
  const [selectedEntry, setSelectedEntry] = useState(null);

  const [selectedType, setSelectedType] = useState(null);
  const [selectionType, setSelectionType] = useState(null);

  const [assignEmployeeId, setAssignEmployeeId] = useState(null);

  const [employeeId, setEmployeeId] = useState(null);
  const [employeelist, setEmployeelist] = useState(null);

  const [unitId, setunitId] = useState([]);
  const [weightUnitId, setweightUnitId] = useState([]);
  const [weightunitList, setweightUnitList] = useState([]);
  const [unitList, setUnitList] = useState();
  const [farmerId, setFarmerId] = useState(null);
  const [farmerlist, setFarmerlist] = useState(null);
  const [harvestDate, setHarvestDate] = useState("");
  const [mrlStatus, setMRLStatus] = useState(null);
  const [cropPlotId, setcropPlotId] = useState(null);
  const [cropPlotList, setcropPlotList] = useState(null);
  const [cropList, setCropList] = useState([]);
  const [cropId, setcropId] = useState(null);

  const [cropVarietyList, setcropVarietyList] = useState([]);
  const [varietyId, setvarietyId] = useState(null);
  const [cropVarietyFliterList, setcropVarietyFliterList] = useState([]);

  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [close, setClose] = useState(false);
  const [cropClose, setCropClose] = useState(false);
  const [procurmentClose, setprocurmentClose] = useState(false);
  const [passType, setPassType] = useState("Purchase");
  const [type_id, setTypeId] = useState();
  const [procIds, setProcIds] = useState();
  const [existingFarmer, setExistingFarmer] = useState(false);
  const [newFarmer, setNewFarmer] = useState(false);
  const [unitsData, setUnitsData] = useState();
  const [docNoFor, setdocNoFor] = useState();

  const [docList, setDocList] = useState([]);
  const [docId, setDocId] = useState([]);

  const [loadQuantityunitId, setLoadQuantityunitId] = useState();
  const [loadQuantityunitList, setLoadQuantityunitList] = useState();

  const [loading, setLoading] = useState(false);

  const { sendRequest: postGatePass } = useHttp();

  const { sendRequest: getFarmerProc } = useHttp();

  const { sendRequest: getEmp } = useHttp();

  // useEffect(() => {
  //   frmRef.current.inTime.value =
  //     (d.getHours() < 10 ? "0" : "") +
  //     d.getHours().toString() +
  //     ":" +
  //     (d.getMinutes() < 10 ? "0" : "") +
  //     d.getMinutes().toString();
  //   //console.log("time_stamp1", frmRef.current.inTime.value);
  // }, [selectedDate]);

  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?useCase=Warehouse&orgId=${localStorage.getItem(
          "orgId"
        )}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("emp", data.output);
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);

  const { sendRequest: getFarmer } = useHttp();

  useEffect(() => {
    getFarmer(
      {
        url: "/api/getAllFarmersWeb/",
        method: "GET",
      },
      (data) => {
        //console.log("setFarmerlist", data);
        setFarmerlist(data);
      }
    );
  }, [getFarmer]);

  const { sendRequest: getUnit } = useHttp();

  const getUnitDetail = () => {
    getUnit(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //console.log("units", res);

          var unitFilter = res.filter((item) => item.unitTypeId == 2);

          //console.log("unitFilter", unitFilter);

          setUnitList(unitFilter);
          setweightUnitList(unitFilter);
        }
      }
    );
  };

  useEffect(() => {
    getUnitDetail();
  }, [getUnit]);

  const { sendRequest: getcrop } = useHttp();
  useEffect(() => {
    getcrop(
      {
        url: "/api/crops/",
      },
      (res) => {
        if (res) {
          //console.log("Crop", res);
          //var cropfilterlist=  res.filter((item) => item.croptypeId == croptypeId);

          setCropList(res);
        }
      }
    );
  }, [getcrop]);

  const cropOnchangedHandler = (event) => {
    //console.log(event.target.value);

    var tempCropId = event.target.value;
    setcropId(event.target.value);
    setcropVarietyFliterList([]);

    //console.log("cropVarietyList", cropVarietyList);
    const FilterList = cropVarietyList.filter(
      (item) => parseInt(item.cropId) === parseInt(tempCropId)
    );

    //console.log("FilterList", FilterList);
    setcropVarietyFliterList(FilterList);
  };

  const { sendRequest: getcropVariety } = useHttp();

  const getCropVarietyDetail = () => {
    getcropVariety(
      {
        url: "/api/varieties/",
      },
      (res) => {
        if (res) {
          //console.log("setcropVarietyList", res);
          setcropVarietyList(res);
        }
      }
    );
  };

  useEffect(() => {
    getCropVarietyDetail();
  }, [getcropVariety]);

  const { sendRequest: getprocurement } = useHttp();

  const getprocurementData = (id) => {
    const pdata = { createdBy: "2" };

    setcropPlotId(null);
    setProductDetails([]);
    getprocurement(
      {
        url: "/api/getAllCropsForGatepass/",
        method: "GET",
      },
      (data) => {
        var cropdata = data.cropDetails.filter((item) => item.farmerId == id);

        //console.log(cropdata);

        setcropPlotList(cropdata);

        var farmerdata = farmerlist.filter((item) => item.farmerId == id);
        if (farmerdata.length > 0) {
          //console.log("farmerdata", farmerdata);
          frmRef.current.personName.value = farmerdata[0].farmerName;
          frmRef.current.email.value = farmerdata[0].email;
          frmRef.current.contactnumber.value = farmerdata[0].mobile;
          frmRef.current.whatAppContactNumber.value = farmerdata[0].mobile;
        }
      }
    );
  };

  useEffect(() => {
    getprocurementData();
  }, [getprocurement]);

  const { sendRequest: getemployeeDataload } = useHttp();

  const getemployeeloaddetail = (id) => {
    //console.log("getemployeeloaddetail");
    //console.log(switchEmplabelFar(selectedType));
    var procItem = cropPlotList.filter((item) => item.cropId == id);

    var url = ``;

    var urlfilter = "";

    if (switchEmplabelFar(selectedType) == "Purchase Order No :") {
      url = `/api/getpurchaseOrderForGRN/?orgId=${localStorage.getItem(
        "orgId"
      )}${urlfilter} `;
    }

    if (switchEmplabelFar(selectedType) == "Harvest No :") {
      url = `/api/harvestVehicleDetailForGetPass/?orgId=${localStorage.getItem(
        "orgId"
      )}${urlfilter} `;
    }

    getemployeeDataload(
      {
        url: url,
      },
      (res) => {
        var newDocList = [];
        //console.log("getpurchaseOrderForGRN", res);
        if (switchEmplabelFar(selectedType) == "Purchase Order No :") {
          if (res.output.length > 0) {
            res.output.forEach((item) => {
              newDocList = newDocList.concat({
                docNo: item.docNo,
                docId: item.purchaseOrderId,
              });
            });
          }
        }

        if (switchEmplabelFar(selectedType) == "Harvest No :") {
          if (res.HarvestBatchTransitlist.length > 0) {
            res.HarvestBatchTransitlist.forEach((item) => {
              newDocList = newDocList.concat({
                docNo: item.harvestNo + "(" + item.vmeNo + ")",
                docId: item.harvestBatchTransitId,
                loadQuantity: item.loadQuantity,
                loadQuantityUnitId: item.loadQuantityUnitId,
                cropName: item.cropName,
                varietyName: item.varietyName,
                unitAbbreviation: item.unitAbbreviation,
                driverName: item.driverName,
                driverMobileNumber: item.driverMobileNumber,
                vehicleNumber: item.vmeNo,
                harvestDate: item.harvestDate,
                cropId: item.cropId,
                varietyId: item.varietyId,
              });
            });
          }
        }

        //console.log("newDocList", newDocList);
        setDocList(newDocList);
      }
    );
  };

  const { sendRequest: getemployeeDocproductDetail } = useHttp();

  const getemployeeDocDetail = (id) => {
    //console.log("getemployeeDocproductDetail");
    //console.log(switchEmplabelFar(selectedType));
    var procItem = cropPlotList.filter((item) => item.cropId == id);

    var url = ``;

    var urlfilter = "";

    if (switchEmplabelFar(selectedType) == "Purchase Order No :") {
      url = `/api/purchaseOrderDetail/?orgId=${localStorage.getItem(
        "orgId"
      )}&purchaseOrderId=${docId}`;
    }

    getemployeeDocproductDetail(
      {
        url: url,
      },
      (res) => {
        var newDocList = [];
        //console.log("getpurchaseOrderForGRN", res);

        if (res.length > 0) {
          res.map((x) => (x["isSave"] = true));
          res.map((x) => (x["itemQuantity"] = x.orderQuantity));

          setProductDetails(res);
        }
      }
    );
  };

  const { sendRequest: getproductgradedetail } = useHttp();

  const loadProcurmentDetail = (id) => {
    var procItem = cropPlotList.filter((item) => item.cropId == id);

    var productDetailsdata = [];
    setProductDetails([]);

    getproductgradedetail(
      {
        url: `/api/product/`,
      },
      (res) => {
        //console.log("getproductgradedetail", res);

        if (procItem.length > 0) {
          var procItem1 = procItem[0];
          setdocNoFor(procItem1.procurementNo);
          setDocId(id);

          //console.log("procItem1", procItem1);

          //console.log("fieldPackaging", "[" + procItem[0].fieldPackaging + "]");

          var fieldPackaging = JSON.parse(procItem[0].fieldPackaging);
          var procurement = JSON.parse(procItem[0].procurement);
          var fieldQc = JSON.parse(procItem[0].fieldQc);

          //console.log("fieldQc", fieldQc);
          //console.log("Procurment", procurement);
          //console.log("fieldPackaging", fieldPackaging);

          setHarvestDate(procurement.procurementDate);
          setMRLStatus(fieldQc.mrlStatus);
          if ((fieldPackaging.batches || "") != "") {
            //console.log("batches", fieldPackaging.batches);

            var batches = JSON.parse(fieldPackaging.batches);
            //console.log("batches", batches);

            var itemlistclass1 = res.filter(
              (item) =>
                parseInt(item.varietyId) == parseInt(procItem1.cropVarietyId) &&
                parseInt(item.gradeId) > 0 &&
                item.gradeName.toLowerCase() == "grade 1" &&
                parseInt(item.inputproductId || "0") == 0
            );

            var itemlistclass2 = res.filter(
              (item) =>
                parseInt(item.varietyId) == parseInt(procItem1.cropVarietyId) &&
                parseInt(item.gradeId) > 0 &&
                item.gradeName.toLowerCase() == "grade 2" &&
                parseInt(item.inputproductId || "0") == 0
            );

            var itemlistclass3 = res.filter(
              (item) =>
                parseInt(item.varietyId) == parseInt(procItem1.cropVarietyId) &&
                parseInt(item.gradeId) > 0 &&
                item.gradeName.toLowerCase() == "grade 3" &&
                parseInt(item.inputproductId || "0") == 0
            );

            var i = 0;
            var k = 1;
            do {
              var sortingDetails = JSON.parse(batches[i].sortingDetails);

              //console.log("sortingDetails", sortingDetails);

              //console.log("itemlistclass1", itemlistclass1);

              if ((sortingDetails.classOneQty || 0) > 0) {
                productDetailsdata = productDetailsdata.concat({
                  srno: k,
                  cropId: procItem1.cropMasterId,
                  cropName: procItem1.cropName,
                  grade: "Grade 1",
                  varietyId: procItem1.cropVarietyId,
                  varietyName: procItem1.cropVariety,
                  itemQuantity: sortingDetails.classOneQty,
                  unit: sortingDetails.classOneUnit,
                  unitId: sortingDetails.classOneUnitId,
                  rate: procItem1.class1Rate || 0,
                  amount:
                    parseFloat(procItem1.class1Rate || 0) *
                    parseFloat(sortingDetails.classOneQty || 0),
                  productId: itemlistclass1[0].productId, //getpassproductdata && getpassproductdata[i].productId,
                  gradeId: itemlistclass1[0].gradeId,
                  createdBy: parseInt(localStorage.getItem("id")),
                  orgId: localStorage.getItem("orgId"),
                  status: 1,
                  isSave: true,
                });

                k++;
              }

              if ((sortingDetails.classTwoQty || 0) > 0) {
                productDetailsdata = productDetailsdata.concat({
                  srno: k,
                  cropId: procItem1.cropMasterId,
                  cropName: procItem1.cropName,
                  grade: "Grade 2",
                  varietyId: procItem1.cropVarietyId,
                  varietyName: procItem1.cropVariety,
                  itemQuantity: sortingDetails.classTwoQty,
                  unit: sortingDetails.classTwoUnit,
                  unitId: sortingDetails.classTwoUnitId,
                  rate: procItem1.class2Rate || 0,
                  amount:
                    parseFloat(procItem1.class2Rate || 0) *
                    parseFloat(sortingDetails.classTwoQty || 0),

                  productId: itemlistclass2[0].productId, //getpassproductdata && getpassproductdata[i].productId,
                  gradeId: itemlistclass2[0].gradeId,
                  createdBy: parseInt(localStorage.getItem("id")),
                  orgId: localStorage.getItem("orgId"),
                  status: 1,
                  isSave: true,
                });

                k++;
              }
              if ((sortingDetails.classThreeQty || 0) > 0) {
                productDetailsdata = productDetailsdata.concat({
                  srno: k,
                  cropId: procItem1.cropMasterId,
                  cropName: procItem1.cropName,
                  grade: "Grade 3",
                  varietyId: procItem1.cropVarietyId,
                  varietyName: procItem1.cropVariety,
                  itemQuantity: sortingDetails.classThreeQty,
                  unit: sortingDetails.classThreeUnit,
                  unitId: sortingDetails.classThreeUnitId,
                  rate: procItem1.class3Rate || 0,
                  amount:
                    parseFloat(procItem1.class3Rate || 0) *
                    parseFloat(sortingDetails.classThreeQty || 0),
                  productId: itemlistclass3[0].productId, //getpassproductdata && getpassproductdata[i].productId,
                  gradeId: itemlistclass3[0].gradeId,
                  createdBy: parseInt(localStorage.getItem("id")),
                  orgId: localStorage.getItem("orgId"),
                  status: 1,
                  isSave: true,
                });
                k++;
              }

              if (
                (sortingDetails.classThreeQty || 0) == 0 &&
                (sortingDetails.classThreeQty || 0) == 0 &&
                (sortingDetails.classThreeQty || 0) == 0
              ) {
                productDetailsdata = productDetailsdata.concat({
                  srno: k,
                  cropId: procItem1.cropMasterId,
                  cropName: procItem1.cropName,
                  grade: "Grade 2",
                  varietyId: procItem1.cropVarietyId,
                  varietyName: procItem1.cropVariety,
                  itemQuantity: batches[i].outputQty,
                  unit: batches[i].outputQtyUnit,
                  unitId: batches[i].outputQtyUnitId,
                  rate: procItem1.class2Rate || 0,
                  amount:
                    parseFloat(procItem1.class2Rate || 0) *
                    parseFloat(batches[i].outputQty || 0),

                  productId: itemlistclass2[0].productId, //getpassproductdata && getpassproductdata[i].productId,
                  gradeId: itemlistclass2[0].gradeId,
                  createdBy: parseInt(localStorage.getItem("id")),
                  orgId: localStorage.getItem("orgId"),
                  status: 1,
                  isSave: true,
                });

                k++;
              }
              i++;
            } while (batches.length > i);
          }
          setProductDetails(productDetailsdata);
          //console.log("productDetails", productDetailsdata);
          //console.log("Procurment totalQty", procurement.totalQty);
          //console.log("Procurment advanceAmount", procurement.advanceAmount);
          //console.log("Procurment advanceAmount", procurement.balanceAmount);
          frmRef.current.loadQuantity.value = procurement.totalQty;
          setLoadQuantityunitId(
            procurement.totalQtyUnitId || productDetailsdata[0].unitId
          );

          var vehicles = JSON.parse(procurement.vehicles);
          frmRef.current.vehicledrivername.value = vehicles[0].driverName;
          frmRef.current.drivercontactnumber.value = vehicles[0].vehicleNumber;
          frmRef.current.vehiclenumber.value = vehicles[0].driverNumber;
        }

        //    setdocNoFor(procurement.procurementNo)
      }
    );
    //  //console.log("deliveryNDispatch",res.DeliveryDispatch[0].dndProductDetails);
    //  setProductDetails(res.DeliveryDispatch[0].dndProductDetails)

    //  frmRef.current.currency.value  =res.DeliveryDispatch[0].currencyCode
    //  setdndId(res.DeliveryDispatch[0].dndId);
  };

  const { sendRequest: getNameById } = useHttp();

  const handleId = (e) => {
    let nurl = `/api/getNamesById/?orgId=${localStorage.getItem("orgId")}`;
    if (selectedEntry && selectedEntry.value === 2) {
      nurl = `${nurl}&existingFarmer=${e.target.value}`;
    } else if (selectedEntry && selectedEntry.value === 3) {
      nurl = `${nurl}&existingEmployee=${e.target.value}`;
    } else {
      nurl = null;
    }
    if (nurl) {
      getNameById(
        {
          url: nurl,
        },
        (res) => {
          if (res) {
            if (selectedEntry && selectedEntry.value === 2) {
              const temp = {
                personName: res.farmerName || "",
                email: res.email || "",
                contactnumber: res.mobile || "",
                contactnumberwork: res.mobile || "",
              };
              setFields({ ...fields, ...temp });
            }

            // frmRef.current.work_contact.value = res.mobile || "";
            // frmRef.current.whatsapp_contact.value = res.mobile || "";
          }
        }
      );
    }
  };

  const { sendRequest: postgatePass } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    setLoading(true);

    var getPassForName = "";

    if (selectedEntry == "New Farmer") {
      getPassForName = frmRef.current.personName.value;
    } else if (selectedEntry == "Existing Farmer") {
      getPassForName = frmRef.current.personName.value;
    } else {
      getPassForName = frmRef.current.personName.value;
    }

    const data = {
      getpassDate: moment(frmRef.current.getpassDate.value).format(
        "DD/MM/YYYY"
      ),

      outTime: frmRef.current.outTime.value,
      farmerId: farmerId,
      FarmerEmployeeId: employeeId,
      cropPlotId: cropPlotId,
      getpassType: selectedEntry.label,
      getpassFor: selectedType.label,
      getpassForId: docId,
      getPassForName: getPassForName,
      gatepassType: "Out",
      docNoFor: docNoFor,
      harvestDate: harvestDate,
      mrlStatus: mrlStatus,
      personName: frmRef.current.personName.value,
      supervisorEmployeeId: assignEmployeeId,
      email: frmRef.current.email.value,
      contactnumber: frmRef.current.contactnumber.value,
      whatAppContactNumber: frmRef.current.whatAppContactNumber.value,
      vehicledrivername: frmRef.current.vehicledrivername.value,
      drivercontactnumber: frmRef.current.drivercontactnumber.value,
      loadQuantity: frmRef.current.loadQuantity.value,
      unitId: loadQuantityunitId,
      remarkNote: frmRef.current.remarkNote.value,
      vehiclenumber: frmRef.current.vehiclenumber.value,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      status: 1,
      warehouseId: parseInt(localStorage.getItem("warehouseId")),
      createdDate: dateString,
      productDetails: productDetails,
    };
    //console.log("data", data);
    if (props.update) {
      data["gatepassId"] = props.update.gatepassId;
    }
    //console.log(data);
    postgatePass(
      {
        url: "/api/gatePass/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(`Getpass Order ${props.update ? "Updated" : "Added"}`);
        props.addForm(false);
        setLoading(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    if (selectedEntry && selectedEntry.value === 1) {
      setFields({ ...fields, farmer_id: parseInt(Date.now() * Math.random()) });
    } else {
      setFields({ ...fields, farmer_id: "" });
    }
    const temp = {
      personName: "",
      email: "",
      contactnumber: "",
      contactnumberwork: "",
    };
    setFields({ ...fields, ...temp });
    setSelectionType(switchType(selectedEntry));
  }, [selectedEntry]);

  //product details modal

  const submitCrop = (e) => {
    e.preventDefault();
    var selectvarietylist = cropVarietyFliterList.filter(
      (item) => item.varietyId == varietyId
    );
    var variety = selectvarietylist && selectvarietylist[0];
    var selectUnitlist = weightunitList.filter(
      (item) => parseInt(item.unitId) == parseInt(weightUnitId)
    );
    var unitData = selectUnitlist && selectUnitlist[0];
    var itemQuantity = productRef.current.cropQuantity.value;
    //console.log(weightUnitId);
    var cropName = variety && variety.cropName;
    var varietyName = variety && variety.varietyName;
    var itemQuantity = productRef.current.cropQuantity.value;
    var unit = unitData && unitData.unitAbbreviation;

    if (!cropName || !varietyName || !itemQuantity || !unit) {
      toast.success("Please fill in all fields!");

      return;
    } else {
      //console.log("select variety", variety);
      //console.log("select productDetails", productDetails);
      const count = productDetails.filter(
        (product) => product.varietyId == variety.varietyId
      ).length;
      //console.log(count);

      if (count > 0) {
        // alert('Item already exists!');

        toast.alert("Variety already exists!");
        return;
      } else {
        setProductDetails((x) => [
          ...x,
          {
            srno:
              productDetails.length > 0
                ? productDetails[productDetails.length - 1].srno + 1
                : 1,
            cropId: cropId,
            cropName: cropName,

            varietyId: varietyId,
            varietyName: varietyName,
            itemQuantity: itemQuantity,
            unit: unit,
            unitId: weightUnitId,
            createdBy: parseInt(localStorage.getItem("id")),
            orgId: localStorage.getItem("orgId"),
            status: 1,
          },
        ]);

        setcropId(0);
        setvarietyId(0);
        setweightUnitId(0);
        productRef.current.cropQuantity.value = "0";
        //console.log(productDetails);
      }
    }
  };
  const handlecropDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const submitProduct = (e) => {
    e.preventDefault();
    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        itemId:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        itemDescription: productRef.current.itemDescription.value,
        itemType: productRef.current.itemType.value,
        itemCategory: productRef.current.itemCategory.value,
        itemQuantity: productRef.current.itemQuantity.value,
        unit: productRef.current.unit.value,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
        status: 1,
      },
    ]);

    //console.log(productDetails);
  };
  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const getProcData = () => {
    let nurl = `/api/getNamesById/?orgId=${localStorage.getItem("orgId")}`;
    nurl = `${nurl}&existingFarmer=${
      frmRef.current.farmer_id.value
    }&procurement=${true}`;
    getFarmerProc(
      {
        url: nurl,
      },
      (res) => {
        if (res) {
          setProcIds(res);
        }
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Getpass-Out Detail</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["getpassDate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="flexColumn15">
                      <label htmlFor={"out_time"}>{"outTime"}</label>
                      <input
                        type={"time"}
                        id={"out_time"}
                        value={fields.outTime}
                        onChange={(e) =>
                          setFields({ ...fields, outTime: e.target.value })
                        }
                        ref={(el) => (frmRef.current["outTime"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="flexColumn15">
                      {/* <label htmlFor={"in_time"}>{"InTime"}</label>
  <input
    type={"time"}
    id={"in_time"}
    required
    onChange={(e) => {
      setFields({ ...fields, inTime: e.target.value });
    }}
    ref={(el) => (frmRef.current["inTime"] = el)}
    // value={fields.inTime}
    className="form-control"
  /> */}
                    </div>

                    <div className="col-md-4">
                      {" "}
                      <label> {`Gate Pass For`}</label>
                      <Select
                        value={selectedEntry}
                        required
                        ref={(el) => (frmRef.current["getpassType"] = el)}
                        onChange={(e) => {
                          setSelectedEntry(e);
                          setSelectedType("");
                          setFields({ ...fields, farmerType: e.value });
                        }}
                        options={farmerTypeOptions}
                      />{" "}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"type"}>{"Type"}</label>
                      <Select
                        value={selectedType}
                        required
                        ref={(el) => (frmRef.current["getpassFor"] = el)}
                        onChange={(e) => {
                          setSelectedType(e);
                          setFields({ ...fields, farmerType: e.value });
                        }}
                        options={selectionType}
                      ></Select>
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"farmer_id"}>
                        {switchEmplabelFar(selectedEntry)}
                      </label>

                      {switchEmpFar(selectedEntry) == "Existing Farmer" ? (
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["farmerId"] = el)}
                          value={farmerId}
                          onChange={(e) => {
                            setFarmerId(e.target.value);
                            getprocurementData(e.target.value);
                            //console.log("farmerId", e.target.value);
                          }}
                        >
                          <option value="">--Select Farmer--</option>
                          {farmerlist &&
                            farmerlist.map((x) => (
                              <option
                                key={x.farmerId}
                                employee-id={x.farmerId}
                                value={x.farmerId}
                                selected={
                                  props.update &&
                                  x.empId === props.update.supervisorEmployeeId
                                }
                              >
                                {x.farmerName + "(" + x.farmerNo + ")"}
                              </option>
                            ))}
                        </select>
                      ) : switchEmpFar(selectedEntry) == "Employee" ? (
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["employeeId"] = el)}
                          value={employeeId}
                          onChange={(e) => {
                            setEmployeeId(e.target.value);
                            getemployeeloaddetail(e.target.value);
                          }}
                        >
                          <option value="">--Select Employee--</option>
                          {employeelist &&
                            employeelist.map((x) => (
                              <option
                                key={x.empId}
                                employee-id={x.empId}
                                value={x.empId}
                              >
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <span></span>

                        //         <input
                        //         type={"text"}
                        //         required
                        //         // disabled={selectedEntry && selectedEntry.value === 1}

                        //         ref={(el) => (frmRef.current["getPassForName"] = el)}
                        //         onBlur={handleId}
                        //         className="form-control"
                        //       />
                      )}

                      {/* {nerr && <p style={{ color: "red" }}>{nerr}</p>} */}
                    </div>

                    {switchEmpFar(selectedEntry) == "Existing Farmer" ? (
                      <div className="col-md-4">
                        <label htmlFor={"docId"}>
                          {" "}
                          {switchEmplabelFar(selectedType)}{" "}
                        </label>
                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["farmerId"] = el)}
                          value={cropPlotId}
                          onChange={(e) => {
                            setcropPlotId(e.target.value);
                            loadProcurmentDetail(e.target.value);
                          }}
                        >
                          <option value="">--Select Procurement No--</option>
                          {cropPlotList &&
                            cropPlotList.map((x) => (
                              <option
                                key={x.cropId}
                                employee-id={x.cropId}
                                value={x.cropId}
                              >
                                {x.procurementNo}
                              </option>
                            ))}
                        </select>
                      </div>
                    ) : switchEmpFar(selectedEntry) == "Employee" ? (
                      <div className="col-md-4">
                        <label htmlFor={"docId"}>
                          {" "}
                          {switchEmplabelFar(selectedType)}{" "}
                        </label>

                        <select
                          id="emp_id"
                          className="form-control"
                          ref={(el) => (frmRef.current["employeeId"] = el)}
                          value={docId}
                          onChange={(e) => {
                            var docid = 0;
                            if (e.target.value != "--Select Doc No--")
                              docid = e.target.value;

                            setDocId(docid);

                            var selectdocList = docList.filter(
                              (item) => item.docId == docid
                            );
                            if (selectdocList && selectdocList.length > 0) {
                              setdocNoFor(selectdocList[0].docNo);
                              setHarvestDate(selectdocList[0].harvestDate);
                            }

                            if (switchEmpFar(selectedType) == "Harvest") {
                              var docitem = selectdocList[0];
                              var productList = [];

                              //console.log("docitem", docitem);

                              setProductDetails((x) => [
                                ...x,
                                {
                                  srno: 1,
                                  cropId: docitem.cropId,
                                  cropName: docitem.cropName,
                                  varietyId: docitem.varietyId,
                                  varietyName: docitem.varietyName,
                                  itemQuantity: docitem.loadQuantity,
                                  unit: docitem.unitAbbreviation,
                                  unitId: docitem.loadQuantityUnitId,
                                  createdBy: parseInt(
                                    localStorage.getItem("id")
                                  ),
                                  orgId: localStorage.getItem("orgId"),
                                  status: 1,
                                  isSave: true,
                                },
                              ]);
                              frmRef.current.loadQuantity.value =
                                docitem.loadQuantity;
                              setLoadQuantityunitId(docitem.loadQuantityUnitId);
                              frmRef.current.vehicledrivername.value =
                                docitem.driverName;
                              frmRef.current.drivercontactnumber.value =
                                docitem.driverMobileNumber;
                              frmRef.current.vehiclenumber.value =
                                docitem.vehicleNumber;
                            } else {
                              getemployeeDocDetail(docid);
                            }
                          }}
                        >
                          <option value="">--Select Doc No--</option>
                          {docList &&
                            docList.map((x) => (
                              <option
                                key={x.docId}
                                doc-id={x.docId}
                                value={x.docId}
                                selected={
                                  props.update &&
                                  x.empId === props.update.supervisorEmployeeId
                                }
                              >
                                {x.docNo}
                              </option>
                            ))}
                        </select>
                      </div>
                    ) : (
                      <span></span>
                      //       <input
                      //   type={"text"}
                      //   required
                      //   // disabled={selectedEntry && selectedEntry.value === 1}

                      //   ref={(el) => (frmRef.current["getPassForNo"] = el)}
                      //   onBlur={handleId}
                      //   className="form-control"
                      // />

                      //   <input
                      //   type={"text"}
                      //   required
                      //   // disabled={selectedEntry && selectedEntry.value === 1}
                      //   value={fields.farmer_id}
                      //   // onBlur={handleId}
                      //   className="form-control"
                      // />
                    )}

                    {/* <TypeGatePass
    setProductDetails={setProductDetails}
    passType={passType}
    setTypeId={setTypeId}
    procIds={procIds}
    type_id={type_id}
    newFarmer={newFarmer}
    getProcData={getProcData}
    existingFarmer={existingFarmer}
  /> */}
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"person_name"}> {"Person Name"}</label>
                      <input
                        type={"text"}
                        id="person_name"
                        required
                        className="form-control"
                        ref={(el) => (frmRef.current["personName"] = el)}
                      />
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"assignEmployeeId"}>
                        {"Assigned Supervisor"}
                      </label>
                      <select
                        id="emp_id"
                        className="form-control"
                        resource=""
                        required
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {
                          setAssignEmployeeId(e.target.value);
                        }}
                      >
                        <option selected value="">
                          --Select Employee--
                        </option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"work_contact"}>{"Contact Number"}</label>
                      <input
                        type={"text"}
                        id={"work_contact"}
                        pattern={integerPattern}
                        required
                        ref={(el) => (frmRef.current["contactnumber"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"whatsapp_contact"}>
                        {"Contact Number(whatsapp)"}
                      </label>
                      <input
                        type={"text"}
                        id={"whatsapp_contact"}
                        pattern={integerPattern}
                        required
                        ref={(el) =>
                          (frmRef.current["whatAppContactNumber"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>{" "}
                      <br />
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        formNoValidate="True"
                        onClick={(e) => {
                          e.preventDefault(false);
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter((x) => x.isSave)
                            );

                          switchEmpFar(selectedEntry) == "Existing Farmer"
                            ? setprocurmentClose(true)
                            : switchEmpFar(selectedEntry) == "New Farmer"
                            ? setCropClose(true)
                            : setClose(true);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <label htmlFor={"driver_name"}>
                        {" "}
                        {"Vehicle Driver Name"}
                      </label>
                      <input
                        type={"text"}
                        id={"driver_name"}
                        required
                        ref={(el) => (frmRef.current["vehicledrivername"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"driver_contact_number"}>
                        {"Vehicle Driver Contact Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"driver_contact_number"}
                        pattern={integerPattern}
                        required
                        ref={(el) =>
                          (frmRef.current["drivercontactnumber"] = el)
                        }
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor={"vehicle_number"}>
                        {"Vehicle Number"}
                      </label>
                      <input
                        type={"text"}
                        id={"vehicle_number"}
                        required
                        ref={(el) => (frmRef.current["vehiclenumber"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"load_quantity"}>{"Load Quantity"}</label>
                      <input
                        type={"text"}
                        id={"load_quantity"}
                        required
                        pattern={decimalPattern}
                        ref={(el) => (frmRef.current["loadQuantity"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"unit"}>{"Unit"}</label>
                      <select
                        id="unitId"
                        className="form-control"
                        ref={(el) =>
                          (frmRef.current["loadQuantityunitId"] = el)
                        }
                        value={loadQuantityunitId}
                        required
                        onChange={(e) => {
                          setLoadQuantityunitId(e.target.value);
                        }}
                      >
                        <option value="">--Select Unit--</option>
                        {unitList &&
                          unitList.map((x) => (
                            <option
                              key={x.unitId}
                              Unit-id={x.unitId}
                              value={x.unitId}
                            >
                              {x.unitAbbreviation}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-4">
                      {" "}
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        ref={(el) => (frmRef.current["remarkNote"] = el)}
                        className="form-control"
                      />{" "}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-1">
          
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default GatePassOutForm;
